/**
 * Staff back-office WebAuthn wrappers. Same shape as the public client's
 * version (`client/src/crypto/webauthn.ts`) — keep them in sync if you
 * change one.
 */

import {
  startAuthentication,
  startRegistration,
} from "@simplewebauthn/browser";
import type {
  PublicKeyCredentialCreationOptionsJSON,
  PublicKeyCredentialRequestOptionsJSON,
  RegistrationResponseJSON,
  AuthenticationResponseJSON,
} from "@simplewebauthn/types";

export async function isPasskeySupported(): Promise<boolean> {
  if (typeof window === "undefined") return false;
  if (typeof window.PublicKeyCredential === "undefined") return false;
  try {
    const available =
      await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable?.();
    return available ?? true;
  } catch {
    return true;
  }
}

export async function createPasskey(
  options: unknown,
): Promise<RegistrationResponseJSON> {
  return startRegistration({
    optionsJSON: options as PublicKeyCredentialCreationOptionsJSON,
  });
}

export async function getPasskey(
  options: unknown,
): Promise<AuthenticationResponseJSON> {
  return startAuthentication({
    optionsJSON: options as PublicKeyCredentialRequestOptionsJSON,
  });
}

export function passkeyErrorName(err: unknown): string | null {
  if (err instanceof Error && "name" in err && typeof err.name === "string") {
    return err.name;
  }
  return null;
}
